import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Assets from '../../Assets/Assets';
import './Header.css';
import AppContext from '../../Context/AppContext';
import NotificationBellModal from '../../Components/NotificationBellModal/NotificationBellModal';
import { GetAPI } from '../../ApiServices/ApiServices'; // Import the GetAPI function

const Header = () => {
  const currentDate = new Date();
  const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
  const formattedDate = currentDate.toLocaleDateString(undefined, options);
  const { user } = useContext(AppContext);

  const [userDetails, setUserDetails] = useState(JSON.parse(localStorage.getItem("loginInfo")));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0); // State to store notification count
  const [notifications, setNotifications] = useState([]); // State to store notifications
  const modalRef = useRef(null);

  useEffect(() => {
    const handleStorageChange = () => {
      setUserDetails(JSON.parse(localStorage.getItem("loginInfo")));
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Fetch notifications when the component mounts
  useEffect(() => {
    const doctorId = localStorage.getItem("userId");

    if (doctorId) {
      GetAPI(`/doctor/notification/${doctorId}`, (response) => {
        if (response.status === 1 && response.code === 200) {
          const transformedNotifications = transformNotifications(response.data);
          setNotifications(transformedNotifications); // Store notifications
          setNotificationCount(transformedNotifications.length); // Update notification count
        }
      });
    }
  }, []);

  // Function to transform the API response
  const transformNotifications = (data) => {
    const transformed = [];

    for (const date in data) {
      for (const appointmentId in data[date]) {
        const appointment = data[date][appointmentId];
        transformed.push({
          id: appointmentId,
          message: `${appointment.appointment_count} Patients are waiting for your appointment on ${appointment.appointment_date}, at ${appointment.slot_time}`,
          icon: Assets.notificationIcon, // Use the correct path to the icon
        });
      }
    }

    return transformed;
  };

  // Close modal on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsModalOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className='header-main'>
      <div className='header-section'>
        <div className='header-left-sec'>
          <p className='user-txt'>Hey, {userDetails?.name}</p>
          <p className='date-txt'>{formattedDate}</p>
        </div>
        <div className='header-right-sec'>
          <div className='notification-wrapper' ref={modalRef}>
            <div className="notification-icon-container">
              <img
                src={Assets.notify_icon}
                alt="Notification"
                className='icon'
                onClick={() => setIsModalOpen(!isModalOpen)}
              />
              {notificationCount > 0 && (
                <span className="notification-badge">
                  {notificationCount >= 10 ? "10+" : notificationCount}
                </span>
              )}
            </div>
            {isModalOpen && (
              <NotificationBellModal notifications={notifications} />
            )}
          </div>
          <Link to="/profile">
            <img
              src={userDetails?.profile_image || Assets.profile_icon}
              alt="Profile"
              className='icon'
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;